import styled from "styled-components";

import { BorderedBox } from "../../css/components";

export const Button = styled.button`
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  
  ${BorderedBox};
`;
